import ZuoraActionType from '../../common/ZuoraActionType';

const initialState = {
  submitDisabled: true,
  zuoraInfo: {},
  loadingHidden: false
};

const ZuoraReducer = (state = initialState, action) => {
  switch (action.type) {
    case ZuoraActionType.DISABLE_SUBMIT: {
      return Object.assign({}, state, { submitDisabled: action.submitDisabled });
    }
    case ZuoraActionType.STORE_ZUORA_INFO: {
      return Object.assign({}, state, { zuoraInfo: action.zuoraInfo });
    }
    case ZuoraActionType.HIDE_LOADING: {
      return Object.assign({}, state, { loadingHidden: action.loadingHidden });
    }
    default:
      return state;
  }
};

export default ZuoraReducer;



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/ZuoraReducer.js
 **/